import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Category extends Component {
	


  	render() {

        let {title,path,thumb} = this.props.category;

        thumb = process.env.REACT_APP_PUBLIC_URL + thumb;
        path = process.env.REACT_APP_PUBLIC_URL + '/' + path;

  		return (

            // <a className="catTile" href={path}>
            <div className="catTile">
            <Link to={path} style={{ textDecoration: 'none' }}> 
                <div className="category-content">
                    <div className="categoryThumb">
                        <img className="thumb" src={thumb} alt="thumb"/>
                    </div>
                    <div className="categoryTitle">
                        {title}
                    </div>
                </div>
            </Link> 
            {/* </a> */}
            </div>
          
  		)
  	}
}

export default Category;
